import { Fx } from 'Components';
import Heading from "../../../NewDashboard/components/Heading";
import styles from "./HeaderRow.module.scss";

type Props = {
	title?: string;
	subHeading?: string;
	parentClass?: string;
	children?: React.ReactNode;
};

const HeaderRow = ({
	title = '',
	subHeading = '',
	parentClass = '',
	children = null
}: Props) => {
	return (
		<Fx
			align="middle"
			justify="space-between"
			className={`${styles.root} ${parentClass}`}
		>
			<Heading
				{...{ title, subHeading }}
				titleClassName={styles.pageTitle}
				subTitleClassName={styles.pageSubTitle}
			/>
			{children}
		</Fx>
	);
};

export default HeaderRow;
